import { render, staticRenderFns } from "./ModalDetailProduct.vue?vue&type=template&id=05bc661e&"
import script from "./ModalDetailProduct.vue?vue&type=script&lang=js&"
export * from "./ModalDetailProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports